import { NextResponse } from "next/server";
import axios from "axios";
import { BaseURL } from "@/Utils/APIRequest/Endpoints";
import { cookies } from "next/headers";

export async function POST(req) {
  const cookieStore = await cookies();
  const accessToken =
    cookieStore.get("iat")?.value || cookieStore.get("verifyUAT")?.value;

  let requestData;
  try {
    requestData = await req.json();
    const { access_token, grant_type = 'ig_exchange_token' } = requestData;

    const response = await axios.get(
      "https://graph.instagram.com/access_token",
      {
        params: {
          grant_type: grant_type,
          client_secret: process.env.INSTAGRAM_SECRET_ID,
          access_token: access_token,
        },
      }
    );

    return NextResponse.json({ data: response.data });
  } catch (error) {
    let payload;

    if (error.response) {
      payload = {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
      };
    } else {
      payload = {
        message: error.message,
      };
    }

    let body = {
      module: "instagram_token_exchange",
      name: error.response?.data?.error?.type || "unknown_error",
      message: error.response?.data?.error?.message || error.message,
      context: {
        url: "https://graph.instagram.com/access_token",
        grant_type: requestData?.grant_type,
      },
    };

    if (accessToken) {
      try {
        await axios.post(`${BaseURL}auth/error-log`, body, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        });
      } catch (logError) {
        console.error("Error logging to backend:", logError);
      }
    }

    return NextResponse.json(
      { error: payload },
      { status: error.response ? error.response.status : 500 }
    );
  }
}
